import React from 'react';

export default class TextInput extends React.Component {
    static defaultProps = {
        id: undefined,
        value : undefined,
        onChange: () => {},
        autoFocus: false
    };

	constructor(props) {
    	super(props);
        
        this.state = {
            initialValue: props.initialValue,
            placeholder: props.placeholder
        }
  	}
    
    componentDidMount() {
        if (this.props.autoFocus) {

            //we focus inside a timeout incase the input is inside a bubble
            //the bubble needs to have time to position itself
            //if we call focus immediately then chrome will scroll up to the top of the page, 
            //which is where the bubble is initially rendered
            setTimeout(e => {
                this.refs.input.focus(); 
            });
        }
    }

    handleOnChange(event) {
        this.props.onChange(event.target.value);
    }

    render() {
        var { placeholder, autoFocus, style, autoFocus } = this.props;
        autoFocus = autoFocus ? true : false;
        
        return (
                <input 
                    ref="input" 
                    type="text" 
                    id={this.props.id} 
                    className="b3-input b3-text" 
                    onChange={this.handleOnChange.bind(this)} 
                    onFocus={this.props.onFocus} 
                    onBlur={this.props.onBlur} 
                    value={this.props.value} 
                    defaultValue={this.state.initialValue} 
                    placeholder={placeholder}
                    style={style}
                    autoFocus={autoFocus}
                />
        );
    }
}

TextInput.defaultProps = {
    onFocus: function() {},
    onBlur: function() {},
    onChange: function() {}
};


// WEBPACK FOOTER //
// ./app/b3/inputs/TextInput.js